import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import { ImageCard } from "../../Global/ImageCard";
import useYearlyRecap from "./useYearlyRecap";
import AddYearlyRecap from "./AddYearlyRecap";
import ViewPreview from "./ViewPreview";
import Style from "./yearlyRecap.module.scss";

const YearlyRecap = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    yearlyRecapList,
    yearlyRecapState,
    recapBasicData,
    isDeleteLoading,
    handleDelete,
    closeImageModal,
    closePreviewModal,
    handleModal,
    setYearlyRecapState,
    handleEditAction,
    updateYearlyRecapTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
    handleDeleteModal,
  } = useYearlyRecap();
  return (
    <>
      <HeadingGroup
        title="Yearly Recap"
        className={`pro-mb-4`}
        buttonTitle={yearlyRecapList?.create_permission && "Create"}
        handleClick={handleModal}
      ></HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: yearlyRecapState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={true}
        />
        {yearlyRecapList?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={yearlyRecapList?.data?.data || []}
            uniqueID={"_id"}
            fields={yearlyRecapState?.tableFeilds || {}}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={yearlyRecapState?.clearSelection}
            perpage={yearlyRecapState?.currentPageSize}
            assignable={false}
            deletable={yearlyRecapList?.delete_permission}
            editable={yearlyRecapList?.edit_permission}
            showCheckBox={
              yearlyRecapList?.delete_permission ||
              yearlyRecapList?.edit_permission
            }
          />
        )}
        {yearlyRecapList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={yearlyRecapState?.currentPage}
            totalPageCount={Math.ceil(
              yearlyRecapList?.data?.total_count /
                yearlyRecapState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === yearlyRecapState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={yearlyRecapList?.fields || []}
              moduleId={yearlyRecapList?.module_id}
              updateData={updateYearlyRecapTableHeadData}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={yearlyRecapState?.showDeleteModal}
          handleClose={() => handleDeleteModal()}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              isLoading={isDeleteLoading}
              title={"Are you sure to delete the selected Yearly Recap ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={() => handleDeleteModal()}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={yearlyRecapState?.showModal}
          handleClose={handleModal}
          title={
            yearlyRecapState?.isEdit
              ? "Update Yearly Recap"
              : "Add Yearly Recap"
          }
          backdrop={"static"}
        >
          <AddYearlyRecap
            refetch={refetch}
            handleModal={handleModal}
            yearlyRecapState={yearlyRecapState}
            setYearlyRecapState={setYearlyRecapState}
            recapBasicData={recapBasicData?.data}
          />
        </OffCanvasLayout>
        <ModalLayout
          show={yearlyRecapState?.showImageModal}
          handleClose={closeImageModal}
          // backdrop="static"
          propStyle={{ root: Style.modal_root_height }}
        >
          <ImageCard
            data={yearlyRecapState?.imageData}
            handleClose={closeImageModal}
          />
        </ModalLayout>
        <ModalLayout
          show={yearlyRecapState?.openPreviewModal}
          handleClose={closePreviewModal}
          title={"Preview "}
          propStyle={{ root: Style.modal_root_width }}
          closeIcon={<span className="material-symbols-outlined">close</span>}

          // backdrop="static"
        >
          <ViewPreview
            type={yearlyRecapState?.previewSlide?.type}
            data={yearlyRecapState?.previewSlide?.data}
          />
        </ModalLayout>
      </div>
    </>
  );
};

export default YearlyRecap;
